<template>
  <div>
    <slot v-bind="removeItem">
      <button @click="removeItem">
        <i class="fal fa-times fa-xl"></i>
      </button>
    </slot>
  </div>
</template>

<script>
import REMOVE_CART_ITEM_MUTATION from "@/queries/Cart/RemoveCartItem.mutation.gql"
import CURRENT_QUERY from "@/queries/Current.query.gql"

export default {
  name: "Cart.RemoveItem",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    cart: null,
  }),
  apollo: {
    cart: {
      query: CURRENT_QUERY,
      update: ({ checkoutCart }) => checkoutCart,
    },
  },
  methods: {
    removeItem() {
      this.$apollo.mutate({
        mutation: REMOVE_CART_ITEM_MUTATION,
        variables: {
          id: parseInt(this.id),
        },
        update: (store, { data: { removeCartItem } }) => {
          const query = CURRENT_QUERY
          const data = store.readQuery({ query })

          data.checkoutCart = { ...data.checkoutCart, ...removeCartItem.cart }
          store.writeQuery({ query, data })
        },
        optimisticResponse: {
          removeCartItem: {
            __typename: "RemoveCartItemMutationPayload",
            cart: {
              ...this.cart,
              items: this.cart.items.filter((i) => i.id != this.id),
            },
          },
        },
      })
    },
  },
}
</script>
